import { useNavigate } from 'react-router-dom'
import { DropdownItem } from 'reactstrap'

export default function CreateMenuItem({ item }) {
  // console.log(`CreateMenuItem rendered: ${name}`)

  const navigate = useNavigate()

  function itemClicked() {
    console.log(`CreateMenuItem clicked: ${item.id}`)
    navigate(`/create/${item.id}`)
  }

  return (
    <DropdownItem onClick={itemClicked} data-cy={`create-menu-item-${item.name.toLowerCase().replace(/ /g, '-')}`}>{item.name}</DropdownItem>
  )
}
